// extracted by mini-css-extract-plugin
module.exports = {"input1":"style_input1__NwXu_","input2":"style_input2__2JyHM","input3":"style_input3__17Hxa","input-select-green":"style_input-select-green__3ZGv3","big":"style_big__1Y6Lt"};